export const WarningIcon = ({
    color = "#A7A7A7",
    width = 19,
    height = 16,
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 19 16"                         // fixed
        preserveAspectRatio="xMidYMid meet"         // ensure centring
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
        {...props}
    >
        <path
            d="M0 15.8333H18.3333L9.16667 0L0 15.8333ZM10 13.3333H8.33333V11.6667H10V13.3333ZM10 10H8.33333V6.66667H10V10Z"
            fill={color}
        />
    </svg>
);